import Vue from 'vue'

class IPLocator {

	constructor(app){
		this.app = app
	}

	async stateFromIP(){
		if (!process || !process.browser){
			console.log("You cannot use this feature with SSR");
			return
		}

		const stateFromCookie = this.app.$cookies.get('state_from_ip_v2')
		if (stateFromCookie){
			return stateFromCookie;
		}

		const stateFromIpQuery = `
			query{
				no_graphql_cache()
				state_from_ip(click_source:"best_plans"){
					id
					sfc_id
					name
					slug
				}
			}
		`
		const result = await this.app.$httpService.graphql(stateFromIpQuery)

		const stateFromService = result.data.state_from_ip
		this.app.$cookies.set('state_from_ip_v2', stateFromService, {
			path: '/',
			domain: 'savingforcollege.com',
			maxAge: 24 * 60 * 60
		})

		return stateFromService
	}

}

export default ({app}) => {
	const locator = new IPLocator(app)

	Vue.prototype.$ipLocator = locator
}
